import { useEffect } from 'react';

import { HeadsetIcon } from '@hugeicons/core-free-icons';
import { useForm } from 'react-hook-form';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, Input, InputGroup, Select } from 'components/FormComponents';

const DURATION_OPTIONS = [24, 1, 2, 4, 8, 48, 72];

const formatDuration = hours => {
  if (hours < 24) return hours + ' ' + (hours === 1 ? 'hour' : 'hours');
  const days = hours / 24;
  return hours + ' hours (' + days + (days === 1 ? ' day)' : ' days)');
};

export const RequestAccessModal = ({ visible, loading, onSubmit, onClose }) => {
  const {
    register,
    watch,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (!visible) reset();
  }, [visible]);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      icon={HeadsetIcon}
      oldIconLibrary={false}
      title="Request Support Access"
      description="Fill out the form below to request access to this client's account"
      small>
      <form onSubmit={handleSubmit(onSubmit)}>
        <InputGroup title="Reason *">
          <Input
            register={register}
            name="reason"
            placeholder="Describe the reason for accessing this account"
            validators={{ required: true }}
            error={errors?.reason?.type}
          />
        </InputGroup>
        <InputGroup title="Ticket Number">
          <Input register={register} name="ticket_number" placeholder="e.g.CSP-1234" />
        </InputGroup>
        <InputGroup title="Duration *">
          <Select
            name="duration_hours"
            register={register}
            value={watch('duration_hours')}
            validators={{ required: true }}
            error={errors?.duration_hours?.type}
            useDefault>
            {DURATION_OPTIONS.map(hours => (
              <Select.Item key={hours} value={hours}>
                {formatDuration(hours)}
              </Select.Item>
            ))}
          </Select>
        </InputGroup>
        <div className="flex justify-end gap-2 mt-2">
          <Button type="secondary" onClick={onClose}>
            Close
          </Button>
          <Button type="primary" loading={loading} submit>
            Request Access
          </Button>
        </div>
      </form>
    </AnimatedModal>
  );
};
